const SEOApiUrl = {
     //#region GetSEOContent
     GetSEOContent: "api/SEOContent/GetSEOContent",
     //#endregion
 }
 export default SEOApiUrl;